var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
/**
 * misuse is thrown when FlexWrapper is consumed without a valid provider being
 * present.
 */
var misuse = new Error("misuse error: no FlexWrapperProvider in ancestors");
/**
 * FlexWrapperFocus is an enum specifying the varius focus targets supported by
 * the FlexWrapper component. This is used to determine focus/render priority on
 * smaller devices, such as mobile.
 */
export var FlexWrapperFocus;
(function (FlexWrapperFocus) {
    /**
     * CONTENT indicates render prioritization for the application's content
     * components.
     */
    FlexWrapperFocus["CONTENT"] = "content";
    /**
     * SIDEBAR indicates render prioritization for the application's Sidebar
     * component.
     */
    FlexWrapperFocus["SIDEBAR"] = "sidebar";
    /**
     * SIDEBAR_INACTIVE indicates that the SIDEBAR is there but should be hidden
     * component.
     */
    FlexWrapperFocus["SIDEBAR_INACTIVE"] = "sidebar-inactive";
})(FlexWrapperFocus || (FlexWrapperFocus = {}));
/**
 * FlexWrapperBindingInit
 */
export var flexWrapperBindingInit = function () { return ({
    setFocus: function (_to) {
        throw misuse;
    },
    getFocus: function () {
        throw misuse;
    },
}); };
/**
 *
 */
var FlexWrapperContext = React.createContext(flexWrapperBindingInit());
/**
 * FlexWrapperProvider is the Provider component of the Flex layout component.
 */
var FlexWrapperProvider = /** @class */ (function (_super) {
    __extends(FlexWrapperProvider, _super);
    /**
     *
     * @param props
     */
    function FlexWrapperProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeFocus: props.defaultFocus,
        };
        _this.setFocus = _this.setFocus.bind(_this);
        _this.getFocus = _this.getFocus.bind(_this);
        return _this;
    }
    /**
     *
     */
    FlexWrapperProvider.prototype.render = function () {
        var className = joinClasses(this.props.className, "scl-b-app", this.props.asWidget ? "scl-b-app__widget" : undefined, FlexWrapperFocus.SIDEBAR === this.getFocus() ? "scl-b-app-sidebar--active" : undefined, FlexWrapperFocus.SIDEBAR_INACTIVE === this.getFocus() ? "scl-b-app-sidebar--inactive" : undefined);
        var setFocus = this.setFocus;
        var getFocus = this.getFocus;
        return (React.createElement(FlexWrapperContext.Provider, { value: {
                setFocus: setFocus,
                getFocus: getFocus,
            } },
            React.createElement("div", { className: className }, this.props.children)));
    };
    /**
     * setFocus implements the setFocus method for the FlexWrapperBinding
     * provided to the Consumers.
     *
     * @param to the new focus priority.
     */
    FlexWrapperProvider.prototype.setFocus = function (to) {
        this.setState({
            activeFocus: to || this.props.defaultFocus,
        });
    };
    /**
     * getFocus implements the getFocus method for the FlexWrapperBinding
     * provided to the Consumers.
     *
     * @return the currently active focus priority.
     */
    FlexWrapperProvider.prototype.getFocus = function () {
        return this.state.activeFocus;
    };
    return FlexWrapperProvider;
}(React.Component));
export { FlexWrapperProvider };
/**
 * FlexWrapperConsumer is the Consumer component of the Flex layout component.
 */
export var FlexWrapperConsumer = FlexWrapperContext.Consumer;
